import { LegacyRef } from 'react'
import { useRecoilValue } from 'recoil'
import { PartnerInfo } from 'src/types/type'
import { PartnerState } from 'src/recoil/ui'
import { BannerWrap } from 'src/styles/common'
import {IMG_SERVER_URL} from "src/service/constants";

interface BannerProps {
  RefElement: LegacyRef<HTMLImageElement>
}
const Banner = ({ RefElement }: BannerProps): JSX.Element => {
  const PartnerData: PartnerInfo = useRecoilValue(PartnerState)
  const { Image1, Image2 } = PartnerData
  // 개발기에는 이미지가 존재하지 않습니다.
  return (
    <BannerWrap>
      <img src={`${IMG_SERVER_URL}/partner/${Image1}`} alt="배너1" />
      <img src={`${IMG_SERVER_URL}/partner/${Image2}`} alt="배너2" ref={RefElement} />
    </BannerWrap>
  )
}
export default Banner
